/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 02 2023
 **/

import { Theme, css, useTheme } from "@emotion/react";
import React from "react";

interface DotProps extends React.HTMLAttributes<HTMLDivElement> {
	size: "s" | "m" | "l" | "xl";
	color: "red" | "gray";
}

const sizeMap: Record<
	DotProps["size"],
	{
		border: UnitString;
		inner: UnitString;
	}
> = {
	s: {
		border: "0px",
		inner: "4px"
	},
	m: {
		border: "0px",
		inner: "6px"
	},
	l: {
		border: "2px",
		inner: "8px"
	},
	xl: {
		border: "2px",
		inner: "10px"
	}
};
export default function Dot({ size, color }: DotProps) {
	const theme = useTheme();
	return <div css={[defaultCss({ theme, size, color })]} />;
}

const defaultCss = ({ theme, size, color }: { theme: Theme; size: DotProps["size"]; color: DotProps["color"] }) => css`
	width: calc(${sizeMap[size].border} + ${sizeMap[size].inner});
	height: calc(${sizeMap[size].border} + ${sizeMap[size].inner});
	border-radius: calc(${sizeMap[size].border} + ${sizeMap[size].inner});
	background-color: ${color === "red" ? theme.colors.error_60_100 : theme.colors.neutral_50_100};
	border: ${sizeMap[size].border} solid #fff;
`;
